import PropTypes from 'prop-types';

const Ignore = ({ color, size, ...props }) => (
    <svg viewBox="0 0 16 16" width={size} height={size} {...props}>
        <path
            d="M7.998 3.522q-.541 0-1.068.123a.75.75 0 1 1-.342-1.461 6 6 0 0 1 1.413-.162c2.367 0 4.177 1.352 5.347 2.601a12.4 12.4 0 0 1 1.696 2.306l.116.214.007.014.002.005.001.001-.67.337.67-.336a.75.75 0 0 1-.009.69 11.7 11.7 0 0 1-1.364 2.014.75.75 0 1 1-1.147-.966q.555-.661.991-1.403a10.878 10.878 0 0 0-1.387-1.85C11.209 4.534 9.769 3.522 8 3.522zm-2.912.013a.75.75 0 0 1-.14 1.05 10.2 10.2 0 0 0-2.587 2.916q.085.143.205.33c.269.417.666.97 1.182 1.52 1.044 1.113 2.482 2.124 4.248 2.126a5.2 5.2 0 0 0 3.061-1.064.75.75 0 0 1 .91 1.193 6.7 6.7 0 0 1-3.953 1.37L8 12.978c-2.368 0-4.177-1.352-5.348-2.6A12.4 12.4 0 0 1 .956 8.07a8 8 0 0 1-.116-.215l-.007-.014-.002-.004-.001-.002.67-.336-.67.335a.75.75 0 0 1 .01-.69 11.65 11.65 0 0 1 3.195-3.751.75.75 0 0 1 1.051.14m2.21 2.2a.75.75 0 0 1-.037 1.06 1.023 1.023 0 1 0 1.445 1.446.75.75 0 1 1 1.097 1.023 2.523 2.523 0 1 1-3.565-3.566.75.75 0 0 1 1.06.038"
            fill={color}
            fillRule="evenodd"
        />
        <path
            d="M.97.47a.75.75 0 0 1 1.06 0l13 13a.75.75 0 1 1-1.06 1.06l-13-13a.75.75 0 0 1 0-1.06"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
);

export default Ignore;

Ignore.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
